import { DataView } from 'primereact/dataview';
import { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import { privateFetch } from '../../../../utils/apiHelper';
import NewsDetail from './NewsDetail';
import NewsItem from './NewsItem';
import NewsManager from './NewsManager';
import styles from "../../../../components/Display/Wrapper.module.scss";

function NewsPage({ isActive }) {
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [newsDetail, setNewsDetail] = useState(undefined);
  const [newsList, setNewslist] = useState([]);
  const [loading, setLoading] = useState(false);
  const { accountContext } = useAccountContext();
  const { setActiveView, navigationContext } = useNavigationContext();
  const [duplicationMode, setDuplicationMode] = useState(false);
  const [layout, setLayout] = useState('grid');

  useEffect(() => {
    fetchNewsList();
  }, [navigationContext]);

  const fetchNewsList = async () => {
    await privateFetch('GET', 'bassecour', `/cu/${accountContext.id}/news/`).then((res) => {
      if (res) setNewslist(res);
    });
  };

  const fetchNewsDetail = async () => {
    await privateFetch(
      'GET',
      'resources',
      `/cu/${accountContext.id}/news/${navigationContext.activeNewsId}/`
    ).then((res) => {
      if (res) setNewsDetail(res);
    });
  };

  const createNews = async (newsForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'bassecour',
      `/cu/${accountContext.id}/news/`,
      "L'article a bien été ajouté",
      JSON.stringify(newsForm)
    ).then(() => {
      fetchNewsList();
      setLoading(false);
      setPanelIsOpen(false);
      setNewsDetail(undefined);
      setDuplicationMode(false);
    });
  };

  const updateNews = async (newsForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'resources',
      `/cu/${accountContext.id}/news/${navigationContext.activeNewsId}/`,
      "L'article a bien été modifié",
      JSON.stringify(newsForm)
    ).then(() => {
      fetchNewsList();
      fetchNewsDetail();
      setLoading(false);
      setPanelIsOpen(false);
    });
  };

  const deleteNews = async (news) => {
    await privateFetch(
      'DELETE',
      'resources',
      `/cu/${accountContext.id}/news/${news.id}/`,
      "L'article a bien été supprimé"
    ).then(() => {
      fetchNewsList();
      setNewsDetail(undefined);
    });
  };

  const handleClickNews = (news) => {
    setActiveView("bacnews", news, "activeNewsId");
  };

  useEffect(() => {
    if (navigationContext.activeNewsId) {
      fetchNewsDetail();
    } else setNewsDetail(undefined);
  }, [navigationContext]);

  const goBackNewsAction = {
    onClick: handleClickNews,
    label: 'Retour à la liste',
    icon: 'pi pi-arrow-left'
  };

  const handleOpenManager = () => {
    setPanelIsOpen(true);
  };
  const toggleLayout = () => {
    setLayout(layout === 'grid' ? 'list' : 'grid');
  };

  const changeLayoutAction = {
    onClick: toggleLayout,
    ariaLabel: "changer le mode d'affichage",
    icon: layout == "grid" ? "pi-list" : 'pi-th-large'
  };
  const newNewsAction = {
    onClick: handleOpenManager,
    label: 'Ajouter une actualité',
    icon: 'pi-plus'
  };

  const handleDuplicateNews = (news) => {
    handleOpenManager();
    setDuplicationMode(true);
    handleClickNews(news);
  };


  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper
        label="Actualités"
        labelAction={handleClickNews}
        actions={newsDetail ? [goBackNewsAction] : [changeLayoutAction, newNewsAction]}
        detail={newsDetail}>
        {newsDetail && !duplicationMode ? (
          <NewsDetail
            news={newsDetail}
            handleUpdateNews={handleOpenManager}
            handleDelete={deleteNews}
          />
        ) : (
          <div className={styles.pageContentContainer}>
            <div className={` ${layout === 'grid' ? styles.gridLayout : styles.listLayout}`}>
              {newsList.map((news, index) => (
                <NewsItem
                  layout={layout}
                  key={index}
                  news={news}
                  handleClickNews={() => handleClickNews(news)}
                  handleDuplicateNews={() => handleDuplicateNews(news)}
                />))}
            </div>
          </div>
        )}
      </PageWrapper>
      <NewsManager
        isOpen={panelIsOpen}
        onClose={() => {
          setDuplicationMode(false);
          setPanelIsOpen(false);
        }}
        news={newsDetail}
        onCreate={createNews}
        onUpdate={updateNews}
        loading={loading}
        duplicationMode={duplicationMode}
      />
    </div>
  );
}

export default NewsPage;
